import cx from 'classnames'
import styles from './PresenceIndicator.module.css'

interface PresenceIndicatorProps {
  present?: boolean
  testId?: string
}

/**
 * A dot that shows whether a user is online.
 */
export function PresenceIndicator({ present, testId }: PresenceIndicatorProps) {
  return (
    <div
      className={cx(styles.root, present && styles.present)}
      data-test={testId && `${testId}-${present}`}
    />
  )
}
